import SubscribeApiWrapper from './SubscribeApiWrapper';
import HubspotApiWrapper from './HubspotApiWrapper';

const subscribeApi = new SubscribeApiWrapper();
const hubspotApi = new HubspotApiWrapper();

export { subscribeApi, hubspotApi };
